import React, { useEffect } from 'react';

import AdComponent from '../../AdTech/adWrapper';

// const GIAdsInitialConfig = {
//   userCallbackForView: function (err, id) {},
//   userClickHandlerForClick: function (err, id) {},
//   onError: function () {
//     console.log('On Error Callback from client');
//   },
//   ORG: 'GI',
//   AUTH_COOKIE_KEY: 'OAUTH-GOIBIBO'
// };

const MMTAd = props => {
  const {
    id,
    lob,
    pageName,
    section,
    cid,
    callInit = true,
    styles = {},
    searchContextDetails = null
  } = props;
  // useEffect(() => {
  //   if (callInit) {
  //     if (window.AdMMTSDK && window.AdMMTSDK.init) {
  //       window.AdMMTSDK.init(GIAdsInitialConfig);
  //     } else {
  //       window.AdMMTSDK = [];
  //       window.AdMMTSDK.push(GIAdsInitialConfig);
  //     }
  //   }
  // }, []);

  return (
    <div style={{ ...styles }}>
      {cid ? (
        <AdComponent uuid={cid} />
      ) : (
        <AdComponent uuid={id} lob={lob} pageName={pageName} section={section} />
      )}
      {/* {cid ? (
        <mmtad
          data-cid={cid}
          {...(searchContextDetails
            ? { 'search-context': JSON.stringify(searchContextDetails) }
            : null)}
          loading="lazy"
        />
      ) : (
        <mmtad
          data-id={id}
          data-lob={lob}
          data-pageName={pageName}
          data-section={section}
          loading="lazy"
          {...(searchContextDetails
            ? { 'search-context': JSON.stringify(searchContextDetails) }
            : null)}
        ></mmtad>
      )} */}
    </div>
  );
};

export default MMTAd;
